import { trackEventNotification } from '../../modules/tracking/utils/tracking';

import { createReducer } from 'utils/redux';

export const RESET_ALL = 'reset_all';
export const NOTIFICATION = 'notification';
export const CLOSE_NOTIFICATION = 'close_notification';
export const CLEAR_NOTIFICATION_BETWEEN_PAGES = 'clear_notification_between_pages';

const DEFAULT_LANGUAGE = 'en';

// @todo: move notifications to different reducer

const initialState = {
  notification: {
    type: '',
    message: '',
    status: 0, // notification.status is used in `src/containers/authenticated.js`
    keepBetweenPages: false
  },

  language: DEFAULT_LANGUAGE
};

export function resetAll() {
  return {
    type: RESET_ALL
  };
}

export function notificationAction(data) {
  return {
    type: NOTIFICATION,
    payload: { data }
  };
}

export function notification(data) {
  const { target, ...params } = data;

  return (dispatch) => {
    dispatch(notificationAction({ ...params }));
    trackEventNotification(data);
  };
}

export function danger(message, params = {}) {
  const type = 'danger';
  return (dispatch) => dispatch(notification({ type, message, ...params }));
}

export function info(message, params = {}) {
  const type = 'info';
  return (dispatch) => dispatch(notification({ type, message, ...params }));
}

export function success(message, params = {}) {
  const type = 'success';
  return (dispatch) => dispatch(notification({ type, message, ...params }));
}

export function closeNotification() {
  return {
    type: CLOSE_NOTIFICATION
  };
}

export function clearNotificationBetweenPages() {
  return {
    type: CLEAR_NOTIFICATION_BETWEEN_PAGES
  };
}

export function routeUpdated() {
  return (dispatch) => {
    dispatch(clearNotificationBetweenPages());
  };
}

export default createReducer('common', initialState, {
  [RESET_ALL]: (state) => ({
    ...initialState,
    notification: state.notification
  }),

  [NOTIFICATION]: (state, { data }) => {
    // notification.status is used in `src/containers/authenticated.js`
    if (state.notification.status >= 400 && !data.status) {
      // if we got critical 401 or 404 from API
      // don't replace with this additionally triggered `danger()` notification
      return state;
    }

    return ({
      ...state,
      notification: data
    });
  },

  [CLOSE_NOTIFICATION]: (state) => ({
    ...state,
    notification: {}
  }),

  [CLEAR_NOTIFICATION_BETWEEN_PAGES]: (state) => ({
    ...state,
    notification: state.notification.keepBetweenPages ? {
      ...state.notification,
      keepBetweenPages: false // keep it only once
    } : {}
  })
});
